import React from 'react';
import styled from 'styled-components';
import { FacebookIcon } from '../../../ui/icons/Facebook';

interface ISocialMedia {
  style?: any;
}

export const SocialMedia: React.FC<ISocialMedia> = ({ style }) => {
  /*   const items = [
    {
      type: 'fb',
      link: `https://www.facebook.com/sharer/sharer.php?u=https://privatmegleren.no/fritid`
    }
  ]; */

  return (
    <SociaMediaStyle style={style}>
      <a href="https://www.facebook.com/sharer/sharer.php?u=https://privatmegleren.no/fritid">
        <FacebookIcon className="icon-facebook" />
      </a>
      {/*       {items.map((key: any, item: any) => {
        if (item.type === 'fb') {
          return (
            <a href={item.link} key={key}>
              <FacebookIcon className="icon-facebook" />
            </a>
          );
        }
      })} */}
    </SociaMediaStyle>
  );
};

const SociaMediaStyle = styled.div`
  display: flex;
  justify-content: center;
  grid-column-gap: 1rem;
  padding-top: 3rem;

  .icon-facebook {
    svg {
      width: 30px;
      height: 30px;
      path {
        fill: ${(props) => props.theme.colors.primary};
      }
    }
  }
`;

export default SocialMedia;
